import ModalFooter, { ModalFooterProps } from './ModalFooter';

export default ModalFooter;
export type { ModalFooterProps };
